import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IResponse from '../../../models/responces/IResponse';

export interface IApiTransactionSetStatusParams {
  hash: string;
  success: boolean;
}
const apiTransactionSetStatus = (params: IApiTransactionSetStatusParams) =>
  sendAxiosRequest({
    method: 'post',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'transaction',
      action: 'set-status',
      id: params.hash
    }),
    data: { success: params.success },
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IResponse>;
export default apiTransactionSetStatus;
